var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-table-layout',[_c('div',{staticClass:"mt-5",attrs:{"slot":"mainContent"},slot:"mainContent"},[_c('h2',[_vm._v("vForms")])])])}
var staticRenderFns = []

export { render, staticRenderFns }